import React from "react";
export default () => <>settings</>;